export class BillReaderContractLocationLookup {
	public contractLocationId: string;
	public contractId: string;
	public contractNum: string;
	public customerName: string;
	public matchedUtilityAccountNum: string;
	public locationAddress: string;
	public utilityAccountNum: string;
	public serviceType: string;
	public annualUsage: number;

	constructor(data?: BillReaderContractLocationLookup) {
		Object.assign(this, data);
	}

	get displayLabel(): string {
		return [this.contractNum, this.matchedUtilityAccountNum || this.utilityAccountNum].filter(Boolean).join(' - ');
	}
}
